import script from "./DeleteOcrProductLineModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteOcrProductLineModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteOcrProductLineModal.vue?vue&type=style&index=0&id=53815f2e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53815f2e"]])

export default __exports__